import { SegnalazioneInput } from "../../services/models/input-objs/SegnalazioneInput"
import { Segnalazione, SegnalazioneFinancialInstrument, SegnalazioneMoreInfoContact, SegnalazioneSuspects } from "../../services/models/objs/Segnalazione"
import { SendingStorOutput } from "../../services/models/output-objs/sendingStoreOutput"
import { GENERATEID } from "./Utils"

const StorBeFeParser = {

    dateConverter(date : string, hour : string){
        
        let dateSupport = new Date('January 1, 1900 00:00:00')
        let hourSupport = '00'
        let minuteSupport = '00'
        if(date){
            dateSupport = new Date(date)
            dateSupport.toLocaleString('it-IT')
        }
        if(hour){
            hourSupport = hour.slice(0, 2);
            minuteSupport = hour.slice(3,5)
        }
        dateSupport.setHours(+hourSupport)
        dateSupport.setMinutes(+minuteSupport)
        return dateSupport.toUTCString()
    },

    parseBetoFe(storBe: Segnalazione): SegnalazioneInput {
        let tmpStorFE : SegnalazioneInput = {}
        const tmpMoreInfoContact: {}[] = []
        const tmpFinancialInstruments : any[] = []
        const tmpFinancialInstrumentsDate : any[] = []
        const tmpFinancialInstrumentsNation : {}[] = []
        const tmpFinancialInstrumentsDescription : {}[] = []
        const tmpSuspects : {}[] = []
        let storType = ''
        switch(storBe.type?.id){
            case 1:
                storType = 'STOR'
                break;
            case 3:
                storType = 'Market Observation'
                break;
            default :
                storType = 'Altro'
       }
        storBe.moreInfoContacts?.forEach((contact : SegnalazioneMoreInfoContact) =>{
            let singleContact = {}
            singleContact = {
                nomeReferente : contact.name,
                cognomeReferente : contact.surname,
                indirizzoMailReferente : contact.email,
                posizioneReferente : contact.position,
                numCellulare : contact.phoneNumber1,
                numTelefono : contact.phoneNumber2,
            }
            tmpMoreInfoContact.push(singleContact)
        })
        storBe.financialInstruments?.forEach((instrument : SegnalazioneFinancialInstrument) =>{
            let SingleFinancialInstrument = {}
            let SingleFinancialInstrumentDate = {}
            let SingleFinancialInstrumentNation = {}
            let SingleFinancialInstrumentDescription = {}
            let idGenerate = GENERATEID()
            let offsite = ''
            if(instrument.offsite === true){
                offsite = 'SI'
            }else if(instrument.offsite === false){
                offsite = 'NO'
            }
            SingleFinancialInstrument = {
                id : idGenerate,
                nomeCompletoODesc : instrument.name,
                codiceIdentificativo : instrument.code,
                tipoCodiceCFI : instrument.cfiType,
                tipoDerivatoOTC : instrument.otcDerivedType,
                importoNominale : instrument.amount,
                valutaDenominazionePrezzo : instrument.currency?.name,
                valutaDenominazionePrezzoId : instrument.currency?.id,
                dataScadenza : instrument.expireDate,
                premio : instrument.premium,
                tassoInteresse : instrument.interestRate,
                margine : instrument.margin,
                pagamentoAnticipato : instrument.prepayment,
                dimensione : instrument.size,
                valoreNominale : instrument.nominalValue,
                prezzoEsercizio : instrument.strikePrice,
                condizioneContrattuali : instrument.contractTerms,
                nomeCompleto : instrument.subDescription,
                codIdentificatoSottostante : instrument.subCode,
                tipoCodiceCFISottostante : instrument.subCfiType,
                nomeSedeNegoziazione : instrument.tradingVenueName,
                codiceSedeNegoziazione : instrument.tradingVenueCode,
                fuoriSede : offsite,
                descrOperSospetteSup : instrument.description,
            }
            if(instrument.orderDate){
                if(instrument.orderDate.startTime === '00:00:00')
                    instrument.orderDate.startTime =''
                if(instrument.orderDate.endTime === '00:00:00')
                    instrument.orderDate.endTime =''
                SingleFinancialInstrumentDate = {
                    id : idGenerate,
                    codiceStrumFinanaziario : instrument.code,
                    dataInizio: instrument.orderDate?.startDate,
                    oraInizio: instrument.orderDate?.startTime,
                    dataFine : instrument.orderDate?.endDate,
                    oraFine : instrument.orderDate?.endTime,
                    fusoOrario : instrument.orderDate?.timeZone?.name,
                    fusoOrarioId : instrument.orderDate?.timeZone?.id
                }
            }
            if(instrument.orderLocation){
                let idList : any[] = []
                let nameList : any[] = []
                let stringedValue : string = ''
                if(instrument.orderLocation.executionCountries && instrument.orderLocation.executionCountries.length > 0){
                    instrument.orderLocation.executionCountries.map((singleCountry)=>{
                        idList.push(singleCountry.id)
                        nameList.push(singleCountry.name)
                        if(stringedValue === '' && singleCountry.name)
                            stringedValue = singleCountry.name
                        else if(singleCountry.name)
                            stringedValue = stringedValue + ', ' + singleCountry.name
                    })
                }
                SingleFinancialInstrumentNation = {
                    id : idGenerate,
                    codiceStrumFinanaziario : instrument.code,
                    nomeCodiceStatoDoveImpartitoOrdineId: instrument.orderLocation?.countryCreated?.id,
                    nomeCodiceStatoDoveImpartitoOrdine : instrument.orderLocation?.countryCreated?.name,
                    nomeCodiceStatoDoveEseguitoOrdineId : idList,
                    nomeCodiceStatoDoveEseguitoOrdine : stringedValue     
                }
            }
            if(instrument.orderDescription || instrument.description)
            {
                if(instrument.description){
                    SingleFinancialInstrumentDescription = {
                        codiceStrumFinanaziario : instrument.code,
                        descrOperSospette : instrument.description,
                    }
                }
                else{
                    SingleFinancialInstrumentDescription = {
                        id : idGenerate,
                        codiceStrumFinanaziario : instrument.code,
                        numeroRiferimentoOrdine : instrument.orderDescription?.refNumber,
                        dataRegolamento : instrument.orderDescription?.dateOfRegulation,
                        oraRegolamento : instrument.orderDescription?.submissionTime,
                        prezzoAcquistoVendita : instrument.orderDescription?.price,
                        volumeQuantitaStrumentiFinanziari : instrument.orderDescription?.numberOfInstrumentations,
                        tipoOrdine : instrument.orderDescription?.orderType,
                        modalitaInoltroOrdine : instrument.orderDescription?.forwardingMode,
                        oraInoltroOrdine : instrument.orderDescription?.forwardingTime,
                        identitaPersonaCheInoltraOrdine : instrument.orderDescription?.personSubmittedBy,
                        identitaPersonaCheRiceveOrdine : instrument.orderDescription?.receiving,
                        mezzoTrasmissioneOrdine : instrument.orderDescription?.transmissionMean,
                        oraModificaCancellazione : instrument.orderDescription?.modificationTime,
                        identitaPersonaCheCancellaOrdine : instrument.orderDescription?.personModifiedBy,
                        naturaDellaModifica : instrument.orderDescription?.reasonForModification,
                        mezzoPerModificaOrdine : instrument.orderDescription?.modifyMean
                    }
                }
            }
            tmpFinancialInstruments.push(SingleFinancialInstrument)
            if(Object.keys(SingleFinancialInstrumentDate).length !== 0)
                tmpFinancialInstrumentsDate.push(SingleFinancialInstrumentDate)
            if(Object.keys(SingleFinancialInstrumentNation).length !== 0)
                tmpFinancialInstrumentsNation.push(SingleFinancialInstrumentNation)
            if(Object.keys(SingleFinancialInstrumentDescription).length !== 0)
                tmpFinancialInstrumentsDescription.push(SingleFinancialInstrumentDescription)
        })
        storBe.suspects?.forEach((suspect:SegnalazioneSuspects) =>{
            let SingleSuspect = {}
            SingleSuspect = {
                nome : suspect.name,
                cognome : suspect.surname,
                formaGiuridica : suspect.legalForm?.name,
                formaGiuridicaId : suspect.legalForm?.id,
                dataNascita : suspect.birthDate,
                numeroIdentificativoNazionale : suspect.idNumber,
                via : suspect.address?.address,
                numeroCivico : suspect.address?.buildingNumber,
                codicePostale : suspect.address?.zipCode,
                localita : suspect.address?.city,
                regione : suspect.address?.region,
                provincia : suspect.address?.province,
                nazione : suspect.address?.country?.name,
                luogo : suspect.location,
                posizione : suspect.position,
                numeroConto : suspect.accountNumber,
                identificativoCliente : suspect.clientIdentifier,
                relazioneConEmittenteStrumFinanziari : suspect.issuerRelationship,
                posizioneSospettato: suspect.suspectRole,
                naturaInterventoSospettato : suspect.suspectActivity,
                entitaPortafoglioSospettato : suspect.portfolioEntity,
                dataInizioRelazioneProfessionale : suspect.professionalRelationshipStartDate,
                tipoAttivitaUnitaNegozazione : suspect.operationType,
                modelliNegoziazioneSospettato : suspect.negotiationModel,
                nomeAltriSoggettiImplicati : suspect.otherSubjectNames,
                attivitaAltriSoggettiImplicati : suspect.activityOtherSubjects
            }
            tmpSuspects.push(SingleSuspect)
        })
        tmpStorFE = {
            identitaSegnalante : {
                persFisicaSegnalante : {
                   nome : storBe.naturalPerson?.name,
                   cognome : storBe.naturalPerson?.surname,
                   posPrezzoSegnalante : storBe.naturalPerson?.position,
                   numeroProtocolloSegnalante : storBe.externalProtocolNumber
                },
                datiAnagraficiSegnalante : {
                    nomeSoggettoSegnalante : storBe.reportingSubject?.name,
                    tipoSoggettoSegnalante : storBe.reportingSubject?.reportingSubjectType?.name,
                    tipoSoggettoSegnalanteId : storBe.reportingSubject?.reportingSubjectType?.id,
                    formaGiuridica: storBe.reportingSubject?.legalForm?.name,
                    formaGiuridicaId: storBe.reportingSubject?.legalForm?.id,
                    codiceLEI : storBe.reportingSubject?.leiCode,
                    via : storBe.reportingSubject?.address?.address,
                    numCivico : storBe.reportingSubject?.address?.buildingNumber,
                    codPostale : storBe.reportingSubject?.address?.zipCode,
                    nazione : storBe.reportingSubject?.address?.country?.name,
                    nazioneId : storBe.reportingSubject?.address?.country?.id,
                    regione : storBe.reportingSubject?.address?.region,
                    provincia : storBe.reportingSubject?.address?.province,
                },
                vesteSegnalante : {
                    vesteSegnalante : storBe.reportingSubject?.reportingSubjectRole?.name,
                    vesteSegnalanteId : storBe.reportingSubject?.reportingSubjectRole?.id,
                    catTipologiaNegoziazione : storBe.reportingSubject?.negotiatedActivityType?.name,
                    catTipologiaNegoziazioneId : storBe.reportingSubject?.negotiatedActivityType?.id,
                    catTipologiaStrumNegoziato : storBe.reportingSubject?.negotiatedInstrumentType?.name,
                    catTipologiaStrumNegoziatoId : storBe.reportingSubject?.negotiatedInstrumentType?.id,
                    relazioneConSoggSegnalato : storBe.reportingSubject?.relationshipDescription,
                    noteTipoVeste : storBe.reportingSubject?.notes
                },
                referenteRichiestaMaggioriInfo : tmpMoreInfoContact
            },
            ordineOperazione : {
                descrStrumFinanziario : tmpFinancialInstruments,
                dataOraOrdine : tmpFinancialInstrumentsDate,
                nazione : tmpFinancialInstrumentsNation,
                descrizioneOrdine : tmpFinancialInstrumentsDescription
            },
            descrizioneNaturaSospetto : {
                naturaSospetto : {
                    natura : storBe.suspicionType?.name,
                    naturaId : storBe.suspicionType?.id,
                },
                motiviSospetto : {
                    motiviSospetto : storBe.suspicionReason,
                }
            },
            identitaDelSospettato : {
                informazioniPersonali : tmpSuspects
            },
            informazioniSupplementariGenerali : {
                informazioniSupplementari : {
                    noteAggiuntive : storBe.notes,
                    iniziativeControSoggettoSegnalato : storBe.reportedSubjectInitiatives
                }
            },
            documentazioneAllegata : {
                documentiAllegati : storBe?storBe.attachments?  storBe.attachments : [] : []
            },
            // documentazioneAllegata: storBe?storBe.attachments?  storBe.attachments : [] : [],
            systemInformations : {
                type : storType,
                state : storBe.state?.name,
                identificativo : storBe.id,
                id : storBe.id,
                codiceProtocollo : storBe.protocolNumber,
                dataInvio : storBe?.sentDate,
                autoritaEsteraId : storBe?.foreignAuthority?.id,
                autoritaEstera : storBe?.foreignAuthority?.name,
                updateReason : storBe?.updateReason,
                pageNumber : storBe?.pageNumber,
            }
        }
        return tmpStorFE
    },

    parseFetoBe(storFe : SegnalazioneInput, storType : string, currentPage : string, id : string|null): SendingStorOutput {
        let tmpStorBe : SendingStorOutput = {}
        const tmpMoreInfoContact: {}[] = []
        const tmpFinancialInstrument : {}[] = []
        const tmpSuspects : {}[] = []
        let tmpOrderExecution : any[] = []
        let storT = 4
        switch(storType){
             case 'STOR':
                 storT = 1;
                 break;
             case 'Market Observation':
                 storT = 3;
                 break;
             default :
                 storT = 4
        }
        storFe.identitaSegnalante?.referenteRichiestaMaggioriInfo?.forEach((referente: any) =>{
             let singleRef = {}
             singleRef = {
                 name : referente.nomeReferente,
                 surname : referente.cognomeReferente,
                 email : referente.indirizzoMailReferente,
                 position : referente.posizioneReferente,
                 phoneNumber1 : referente.numCellulare,
                 phoneNumber2 : referente.numTelefono,
             }
             tmpMoreInfoContact.push(singleRef)
        })
        storFe.ordineOperazione?.descrStrumFinanziario?.forEach((strumento:any)=>{
             let InstrumentDateArray = {}
             let InstrumentDescriptionArray = {}
             let InstrumentLocationArray = {}
             let singleDataOrder = {}
             let singleDescriptionOrder = {}
             let singleLocationOrder = {}
             let orderDesc = ''
             if(storFe.ordineOperazione?.dataOraOrdine?.constructor === Array){
                storFe.ordineOperazione?.dataOraOrdine?.forEach((dataStrumento:any)=>{
                    if(dataStrumento.codiceStrumFinanaziario === strumento.codiceIdentificativo){
                        let dateInizio = this.dateConverter(dataStrumento.dataInizio, dataStrumento.oraInizio)
                        let dateFine = this.dateConverter(dataStrumento.dataFine, dataStrumento.oraFine)
                        singleDataOrder = {}
                        singleDataOrder = {
                            start : dateInizio,
                            end : dateFine,
                            timezoneId : dataStrumento.fusoOrarioId
                        }
                        InstrumentDateArray = singleDataOrder
                    }
                })
             }
             else{
                singleDataOrder = {}
                let dateInizio = this.dateConverter(storFe.ordineOperazione?.dataOraOrdine?.dataInizio, storFe.ordineOperazione?.dataOraOrdine?.oraInizio)
                let dateFine = this.dateConverter(storFe.ordineOperazione?.dataOraOrdine?.dataFine, storFe.ordineOperazione?.dataOraOrdine?.oraFine)
                singleDataOrder = {
                    start : dateInizio,
                    end : dateFine,
                    timezoneId : storFe.ordineOperazione?.dataOraOrdine?.fusoOrarioId
                }
                InstrumentDateArray = singleDataOrder
             } 
             if(storFe.ordineOperazione?.nazione?.constructor === Array){
                storFe.ordineOperazione?.nazione?.forEach((location:any)=>{
                    tmpOrderExecution = location.nomeCodiceStatoDoveEseguitoOrdineId
                    if(location.codiceStrumFinanaziario === strumento.codiceIdentificativo){
                        singleLocationOrder = {}
                        singleLocationOrder = {
                            countryIdCreated : location.nomeCodiceStatoDoveImpartitoOrdineId,
                            countriesIdExecuted : tmpOrderExecution? tmpOrderExecution:[],
                        }
                        InstrumentLocationArray = singleLocationOrder
                    }
                    tmpOrderExecution = []
                })
             }
             else{
                singleLocationOrder = {}
                tmpOrderExecution = storFe.ordineOperazione?.nazione?.nomeCodiceStatoDoveEseguitoOrdineId
                singleLocationOrder = {
                    countryIdCreated : storFe.ordineOperazione?.nazione?.nomeCodiceStatoDoveImpartitoOrdineId,
                    countriesIdExecuted : tmpOrderExecution? tmpOrderExecution:[]
                }
                InstrumentLocationArray = singleLocationOrder
                tmpOrderExecution = []
             }
             if(storFe.ordineOperazione && storFe.ordineOperazione.descrizioneOrdine?.constructor !== Array){
                orderDesc = storFe.ordineOperazione?.descrizioneOrdine?.descrizioneOrdine
             }
             else if(storFe.ordineOperazione?.descrizioneOrdine && storFe.ordineOperazione?.descrizioneOrdine?.constructor === Array){
                 storFe.ordineOperazione?.descrizioneOrdine?.forEach((descriptionStrumento:any)=>{
                     if(descriptionStrumento.codiceStrumFinanaziario === strumento.codiceIdentificativo){
                         singleDescriptionOrder = {}
                         singleDescriptionOrder = {
                            refNumber: descriptionStrumento.numeroRiferimentoOrdine,
                            dateOfRegulation : descriptionStrumento.dataRegolamento,
                            submissionTime : descriptionStrumento.oraRegolamento,
                            price : isNaN(+descriptionStrumento.prezzoAcquistoVendita)?  undefined : +descriptionStrumento.prezzoAcquistoVendita,
                            numberOfInstrumentations : descriptionStrumento.volumeQuantitaStrumentiFinanziari,
                            orderType : descriptionStrumento.tipoOrdine,
                            forwardingMode : descriptionStrumento.modalitaInoltroOrdine,
                            forwardingTime : descriptionStrumento.oraInoltroOrdine,
                            personSubmittedBy : descriptionStrumento.identitaPersonaCheInoltraOrdine,
                            receiving : descriptionStrumento.identitaPersonaCheRiceveOrdine,
                            transmissionMean : descriptionStrumento.mezzoTrasmissioneOrdine,
                            modificationTime : descriptionStrumento.oraModificaCancellazione,
                            personModifiedBy : descriptionStrumento.identitaPersonaCheCancellaOrdine,
                            reasonForModification : descriptionStrumento.naturaDellaModifica,
                            modifyMean : descriptionStrumento.mezzoPerModificaOrdine
                         }
                     }
                     InstrumentDescriptionArray = singleDescriptionOrder
                 })
             }
             let offsiteBool = null
             if(strumento.fuoriSede === 'SI'){
                offsiteBool = true
             }else if(strumento.fuoriSede === 'NO'){
                offsiteBool = false
             }
             const singleInstrument: any = {
                name : strumento.nomeCompletoODesc,
                code : strumento.codiceIdentificativo,
                cfiType : strumento.tipoCodiceCFI,
                otcDerivedType : strumento.tipoDerivatoOTC,
                amount: strumento.importoNominale ? (isNaN(+strumento.importoNominale)?  undefined : +strumento.importoNominale) : undefined,
                currencyId : strumento.valutaDenominazionePrezzoId,
                expireDate : strumento.dataScadenza,
                premium : strumento.premio ? (isNaN(+strumento.premio)?  undefined : +strumento.premio) : undefined,
                interestRate : strumento.tassoInteresse? (isNaN(+strumento.tassoInteresse)?  undefined : +strumento.tassoInteresse) : undefined,            
                margin : strumento.margine? (isNaN(+strumento.margine)?  undefined : +strumento.margine) : undefined,
                prepayment : strumento.pagamentoAnticipato? (isNaN(+strumento.pagamentoAnticipato)?  undefined :  +strumento.pagamentoAnticipato) : undefined,
                size : strumento.dimensione,
                nominalValue : strumento.valoreNominale? (isNaN(+strumento.valoreNominale)?  undefined :  +strumento.valoreNominale) : undefined,
                strikePrice : strumento.prezzoEsercizio? (isNaN(+strumento.prezzoEsercizio)?  undefined : +strumento.prezzoEsercizio): undefined,
                contractTerms : strumento.condizioneContrattuali,
                subDescription : strumento.nomeCompleto,
                subCode : strumento.codIdentificatoSottostante,
                subCfiType : strumento.tipoCodiceCFISottostante,
                tradingVenueName : strumento.nomeSedeNegoziazione,
                tradingVenueCode : strumento.codiceSedeNegoziazione,
                offsite : offsiteBool,
                orderDate : Object.keys(InstrumentDateArray).length !== 0? InstrumentDateArray : null,
                orderDescription : Object.keys(InstrumentDescriptionArray).length !== 0? InstrumentDescriptionArray : null,
                description : orderDesc,
                orderLocation : Object.keys(InstrumentLocationArray).length !== 0? InstrumentLocationArray : null
             }
             tmpFinancialInstrument.push(singleInstrument)
        })
        storFe.identitaDelSospettato?.informazioniPersonali?.forEach((sospetto : any) => {
             let singleSuspect = {}
             singleSuspect = {
                 name : sospetto.nome,
                 surname : sospetto.cognome,
                 legalForm : sospetto.formaGiuridicaId,
                 birthDate : sospetto.dataNascita,
                 idNumber : sospetto.numeroIdentificativoNazionale,
                 address : {
                     address : sospetto.via,
                     buildingNumber : sospetto.numeroCivico,
                     zipCode : sospetto.codicePostale,
                     city: sospetto.localita,
                     region : sospetto.regione,
                     province : sospetto.provincia,
                     countryId : sospetto.nazioneId
                 },
                 location : sospetto.luogo,
                 position : sospetto.posizione,
                 accountNumber : sospetto.numeroConto,
                 clientIdentifier : sospetto.identificativoCliente,
                 issuerRelationship : sospetto.relazioneConEmittenteStrumFinanziari,
                 suspectRole : sospetto.posizioneSospettato,
                 suspectActivity : sospetto.naturaInterventoSospettato,
                 portfolioEntity : sospetto.entitaPortafoglioSospettato,
                 professionalRelationshipStartDate : sospetto.dataInizioRelazioneProfessionale,
                 operationType : sospetto.tipoAttivitaUnitaNegozazione,
                 negotiationModel : sospetto.modelliNegoziazioneSospettato,
                 otherSubjectNames : sospetto.nomeAltriSoggettiImplicati,
                 activityOtherSubjects : sospetto.attivitaAltriSoggettiImplicati
             }
             tmpSuspects.push(singleSuspect)
        })
        tmpStorBe = {
         storId : id,
         protocolNumber : storFe.systemInformations?.codiceProtocollo,
         sentDate : storFe.systemInformations?.dataInvio,
         foreignAuthorityId: storFe.systemInformations?.autoritaEsteraId,
         updateReason:  storFe.systemInformations?.updateReason,
         storTicketTypeId : storT,
         pageNumber : +currentPage,
         externalProtocolNumber : storFe.identitaSegnalante?.persFisicaSegnalante?.numeroProtocolloSegnalante,
         reportingNaturalPerson : {
             name : storFe.identitaSegnalante?.persFisicaSegnalante?.nome,
             surname : storFe.identitaSegnalante?.persFisicaSegnalante?.cognome,
             position : storFe.identitaSegnalante?.persFisicaSegnalante?.posPrezzoSegnalante,
         },
         reportingSubjectAnagraph : {
             name : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.nomeSoggettoSegnalante,
             reportingSubjectTypeId : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.tipoSoggettoSegnalanteId,
             legalFormId : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.formaGiuridicaId,
             leiCode : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.codiceLEI,
             address: {
                 address : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.via,
                 buildingNumber : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.numCivico,
                 zipCode : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.codPostale,
                 countryId : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.nazioneId,
                 region : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.regione,
                 province : storFe.identitaSegnalante?.datiAnagraficiSegnalante?.provincia,
             },
             reportingSubjectRoleId : storFe.identitaSegnalante?.vesteSegnalante?.vesteSegnalanteId,
             notes : storFe.identitaSegnalante?.vesteSegnalante?.noteTipoVeste,
             negotiatedActivityKindId : storFe.identitaSegnalante?.vesteSegnalante?.catTipologiaNegoziazioneId,
             negotiatedInstrumentKindId : storFe.identitaSegnalante?.vesteSegnalante?.catTipologiaStrumNegoziatoId,
             relationshipDescription : storFe.identitaSegnalante?.vesteSegnalante?.relazioneConSoggSegnalato,        
            },
         moreInfoContact : tmpMoreInfoContact,
         financialInstruments : tmpFinancialInstrument,
         suspicionTypeId : storFe.descrizioneNaturaSospetto?.naturaSospetto?.naturaId,
         suspicionReason : storFe.descrizioneNaturaSospetto?.motiviSospetto?.motiviSospetto,
         suspects : tmpSuspects,
         notes : storFe.informazioniSupplementariGenerali?.informazioniSupplementari?.noteAggiuntive,
         reportedSubjectInitiatives : storFe.informazioniSupplementariGenerali?.informazioniSupplementari?.iniziativeControSoggettoSegnalato
        }
        return tmpStorBe
    }
}


export default StorBeFeParser